import constv from '@/config/constv'
import html2canvas from 'html2canvas'
// 创建用于绘制的基础canvas画布
function createBaseCanvas (scale, width, height) {
  const canvas = document.createElement('canvas')
  canvas.width = width * scale
  canvas.height = height * scale

  const context = canvas.getContext('2d')

  // 关闭抗锯齿
  context.mozImageSmoothingEnabled = false
  context.webkitImageSmoothingEnabled = false
  context.msImageSmoothingEnabled = false
  context.imageSmoothingEnabled = false

  context.scale(scale, scale)

  return canvas
}

// 生成快照
function convertToImage (container, options = {}) {
  // 设置放大倍数
  const scale = window.devicePixelRatio || 1

  // 传入节点原始宽高
  const width = container.offsetWidth
  const height = container.offsetHeight
  // 创建用于绘制的基础canvas画布
  const canvas = createBaseCanvas(scale, width, height)

  // html2canvas配置项
  const ops = {
    scale,
    width,
    height,
    useCORS: true,
    allowTaint: false,
    ...options
  }

  return html2canvas(container, ops)
}

const func = {
  /**
     *
     * @param {*} type  图片类型 1场景 2贴图 3人设背景 4 zpace用户上传 5 水印图片
     * @param {*} url  图片地址
     */
  ImageCdn (type = '1', url) {
    const domainMaps = {
      '1': constv.QINIU_IMAGE_CND_URL,
      '2': constv.QINIU_IMAGE_CND_URL,
      '3': constv.QINIU_IMAGE_QNC_CDN_URL,
      '4': constv.QINIU_IMAGE_USERRESOURCE_CND_URL,
      '5': constv.QINIU_IMAGE_WATERMARK_CND_URL
    }
    if (type == '5') {
      return `${constv.QINIU_IMAGE_WATERMARK_CND_URL}${url}${constv.QINIU_IMAGE_WATERMARK_CND_CODE}`
    } else {
      return `${domainMaps[type]}${url}`
    }
  },
  convertToImage
}

export default {
  install (Vue) {
    Vue.prototype.$func = func
  }
}
